module.exports = __webpack_public_path__ + "img/Cypress 960x1080 v2.6a3efcb1.png";